import React from 'react';
const RoutesContext = React.createContext();
export const RoutesContextProvider = RoutesContext.Provider;
export const RoutesContextConsumer = RoutesContext.Consumer;
